var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }